import React from 'react';
import CommunityRepresentativeModal from 'parent-portal/community/CommunityRepresentativeModal';
import DiscoverySourcePopUp from 'reusableComponents/DiscoverySourcePopUp';
import { useNotificationContext } from '../NotificationContext/NotificationContext';

export default function NotificationModals() {
    const { modalsOpen, closeModal } = useNotificationContext();

    return (
        <>
            <DiscoverySourcePopUp
                open={modalsOpen.discoverySource}
                onClose={() => {
                    closeModal('discoverySource');
                }}
            />
            <CommunityRepresentativeModal
                open={modalsOpen.communityRepresentative}
                onClose={() => {
                    closeModal('communityRepresentative');
                }}
            />
        </>
    );
}
